var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlusCircleIcon = function SvgPlusCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56271"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108649",
    d: "M13.486 9.303h-2.789V6.517a.7.7 0 1 0-1.394 0v2.789H6.517a.7.7 0 1 0 0 1.394h2.789v2.789a.7.7 0 0 0 1.394 0v-2.792h2.789a.7.7 0 0 0 0-1.394Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108650",
    d: "M10 0a10 10 0 1 0 10 10A10.029 10.029 0 0 0 10 0Zm0 18a8 8 0 1 1 8-8 8.024 8.024 0 0 1-8 8Z"
  }))));
};
export default SvgPlusCircleIcon;